import React, { Component } from "react";

import { withRouter } from "react-router";
import { observer } from "mobx-react";
import { FlexboxGrid, Icon, IconButton, Steps } from "rsuite";
import { Notification } from "rsuite";
import Col4 from "../../../../../../Components/Columns/Col4";
import Col2 from "../../../../../../Components/Columns/Col2";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import aimInvoiceStore from "../../../../../../Stores/Financial/AIMInvoiceStore";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import UnifiedModal from "../../../../../../Components/Modal/UnifiedModal";
import axios from "axios";
import baseURL from "../../../../../../Static/baseURL/baseURL";
import userStore from "../../../../../../Stores/UserStore";

const instance = axios.create({ baseURL: baseURL });

class NewAIMInvoiceModal extends Component {
  constructor(props) {
    super(props);
    this.state = { step: 1, loading: false };
    this.changeStep = this.changeStep.bind(this);
    this.onHide = this.onHide.bind(this);
    this.postNewInvoice = this.postNewInvoice.bind(this);
  }
  onHide() {
    if (!this.state.loading) {
      this.setState({ step: 1 });
      this.props.onHide();
    }
  }
  changeStep(val) {
    this.setState({ step: this.state.step + val });
  }

  postNewInvoice = async () => {
    let data = aimInvoiceStore.newaiminvoice;

    let charges = [];
    let singlecharge = {};

    for (let i = 0; i < data.charges.length; i++) {
      singlecharge = {
        title: data.charges[i].title,
        type: data.charges[i].type,
        price: data.charges[i].price,
        aimorder: data.charges[i].aimorder,
      };
      charges = [...charges, singlecharge];
    }

    let final = {
      clientname: data.clientname,
      clientemail: data.clientemail,
      clientphone: data.clientphone,
      title: data.title,
      date: data.date,
      status: data.status,
      remarks: data.remarks,
      client: data.client,
      showBank: data.showBank,
      invnotes: data.invnotes,
      charges: charges,
    };

    let url = "";
    url = `jf/aiminvoice/new`;

    this.setState({ loading: true });
    await instance
      .post(url, final, {
        headers: { authtoken: userStore.token },
      })
      .then((res) => {
        this.setState({ loading: false });
        this.onHide();
        Notification["success"]({ title: `New AIM Invoice Created` });
        aimInvoiceStore.getInvPayments(true);
      })
      .catch((err) => {
        this.setState({ loading: false });
        Notification["error"]({ title: `An error occured` });
      });
  };
  render() {
    let disabled = false;
    let content;
    let inv = aimInvoiceStore.newaiminvoice;
    let step = this.state.step;
    if (step === 1) {
      content = <Step1 />;
      if (inv.title === "") disabled = true;
    } else if (step === 2) {
      content = <Step2 />;
      if (inv.charges.length <= 0) disabled = true;
    } else if (step === 3) {
      content = <Step3 />;
    } else if (step === 4) {
      content = <Step4 />;
    }

    return (
      <div>
        <UnifiedModal
          show={this.props.show}
          title={`Create a New Invoice`}
          onHide={this.onHide}
          footer={<div />}
        >
          <Steps current={step - 1}>
            <Steps.Item title="Invoice Main Info" />
            <Steps.Item title="Select Charges" />
            <Steps.Item title="Invoice Notes" />
            <Steps.Item title="Save" />
          </Steps>
          <FlexboxGrid>
            <Col4>
              {step !== 1 && (
                <IconButton
                  loading={this.state.loading}
                  icon={<Icon icon="left" />}
                  color="orange"
                  onClick={() => this.setState({ step: step - 1 })}
                  block
                >
                  Back
                </IconButton>
              )}
            </Col4>
            <Col2 />
            {step < 4 ? (
              <Col4>
                <IconButton
                  loading={this.state.loading}
                  icon={<Icon icon="right" />}
                  color="green"
                  onClick={() => {
                    this.setState({ step: step + 1 });
                  }}
                  block
                  placement="right"
                  disabled={disabled}
                >
                  Next
                </IconButton>
              </Col4>
            ) : (
              <Col4>
                <IconButton
                  loading={this.state.loading}
                  icon={<Icon icon="save" />}
                  color="green"
                  onClick={() => {
                    this.postNewInvoice();
                  }}
                  block
                  placement="right"
                >
                  Create New Invoice
                </IconButton>
              </Col4>
            )}
          </FlexboxGrid>
          {content}
        </UnifiedModal>
      </div>
    );
  }
}

export default withRouter(observer(NewAIMInvoiceModal));
